export default "__VITE_ASSET__ywaikW9I__"